import React from 'react';
import BlazeLink from '../BlazeLink';
import SearchContentItems from './SearchContentItems';

const SearchContentResults = ({ results, debouncedSearchTerm, onClick }) => {
  if (!debouncedSearchTerm) return null;
  const hasResults = results.length > 0;
  return (
    <div className="search-content--results__wrapper">
      <div className="search-content--results__wrapper--message">
        <div className="search-content--results__content">
          {hasResults ? (
            <SearchContentItems results={results} onClick={onClick} />
          ) : (
            <div className="search-content--results__message">
              <BlazeLink href={`/search?search_term=${debouncedSearchTerm}`}>
                {`Search all results for: ${debouncedSearchTerm}`}
              </BlazeLink>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchContentResults;
